/**
 * 左下角图例（对齐高保真原型 `renderLegend()`）。
 *
 * 原型标题「健康度语义」，恰 3 项：
 *   健康 ≥ 85 / 预警 60 – 85 / 告警 < 60（呼吸提示）
 *
 * ⚠️ 原型没有「筹备中」「跨省协同」——已删除。
 */

const ITEMS: ReadonlyArray<{ color: string; label: string }> = [
  { color: 'var(--ok)', label: '健康 ≥ 85' },
  { color: 'var(--warn)', label: '预警 60 – 85' },
  { color: 'var(--alert)', label: '告警 < 60（呼吸提示）' },
];

export default function Legend() {
  return (
    <div className="map-legend">
      <div className="lt">健康度语义</div>
      {ITEMS.map((it) => (
        <div className="li" key={it.label}>
          <span
            className="ld"
            style={{ background: it.color, boxShadow: `0 0 9px ${it.color}` }}
          />
          {it.label}
        </div>
      ))}
    </div>
  );
}
